import { render, staticRenderFns } from "./Monochrome.vue?vue&type=template&id=006f2bd2&"
import script from "./Monochrome.vue?vue&type=script&lang=js&"
export * from "./Monochrome.vue?vue&type=script&lang=js&"
import style0 from "./Monochrome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports